module.exports = __webpack_public_path__ + "static/img/form-apply.8f7b1cc6.png";